// extracted by mini-css-extract-plugin
export default {"root":"Card_root__QFLo6","header":"Card_header__83TWt","content":"Card_content__rZPAo"};